const getDefaultValue = (component, variableName) => {
    var _a;
    const variable = component.findVariable(variableName);
    return (_a = variable === null || variable === void 0 ? void 0 : variable.values) === null || _a === void 0 ? void 0 : _a.default;
};
export class ExtensionComponentAdapter {
    constructor(component) {
        this.component = component;
    }
    getID() {
        return this.component.id;
    }
    getName() {
        return this.component.name;
    }
    getTitle() {
        return this.component.getDisplayName();
    }
    getCampaignID() {
        return this.component.campaign_id;
    }
    getShortDescription() {
        const shortDescription = getDefaultValue(this.component, "short.description");
        return shortDescription;
    }
    getComponentDescription() {
        return this.component.description || "";
    }
    getDescription(priority = "short") {
        const shortDescription = getDefaultValue(this.component, "short.description");
        const longDescription = this.getComponentDescription();
        if (priority === "default") {
            return longDescription || shortDescription;
        }
        return shortDescription || longDescription;
    }
    getOwner() {
        return this.component.owner;
    }
    getTypeCategories() {
        return (getDefaultValue(this.component, "categories.type") || []);
    }
    getFunctionalityCategories() {
        return (getDefaultValue(this.component, "categories.functionality") || []);
    }
    getCategories() {
        return [
            ...(this.getTypeCategories() || []),
            ...(this.getFunctionalityCategories() || []),
        ].join(", ");
    }
    getListOfCategories() {
        return this.getTypeCategories().concat(this.getFunctionalityCategories());
    }
    isInstallable() {
        return this.component.tags.includes("internal:self-managed");
    }
    getStatus() {
        if (!this.isInstallable()) {
            return "UNAVAILABLE";
        }
        return this.getOwner() === "EXTOLE" ? "NOT_INTEGRATED" : "INTEGRATED";
    }
    getAbout() {
        return getDefaultValue(this.component, "about");
    }
    getExternalUrl() {
        return getDefaultValue(this.component, "external.url");
    }
    getDocumentationUrl() {
        return getDefaultValue(this.component, "documentation.url");
    }
    getLogo() {
        return getDefaultValue(this.component, "icon");
    }
}
